import { FC } from "react";
import { TabButtonProps } from "./types";

const DefaultTabButton:FC<TabButtonProps> = ({label, callback, isActive}) => {
  return (
    <button 
      type="button"
      className={`
        py-4 px-2 inline-flex items-center gap-x-2 border-b-2 border-transparent whitespace-nowrap
        
        ${
          isActive
            ? 'font-semibold border-green text-green' 
            : ''
        } 
        text-black
        hover:text-green 
        focus:outline-none focus:text-green 
        disabled:opacity-50 disabled:pointer-events-none
        text-lg md:text-xl
      `}
      onClick={callback}
    >
      {label}
    </button>
  );
}

export default DefaultTabButton;